/**
 * RequestCommentService
 * Service for RequestComment entity operations
 * Route: api/requestcomment
 * Controller: RequestCommentController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RequestCommentService
 * Handles request comment CRUD operations
 * Maps to /api/requestcomment endpoint
 */
export class RequestCommentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestCommentService.DEFAULT_SERVICE_PATH,
            basePath: RequestCommentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAllViewModels() {
        const response = await this.http.get(this.buildUrl('view-models'));
        return response.data ?? [];
    }
    async getViewModelsByRequest(requestId) {
        const response = await this.http.get(this.buildUrl(`view-models/by-request/${requestId}`));
        return response.data ?? [];
    }
}
RequestCommentService.DEFAULT_SERVICE_PATH = 'procurements';
RequestCommentService.BASE_PATH = 'api/requestcomment';
//# sourceMappingURL=RequestCommentService.js.map